import { Autocomplete, TextField } from "@mui/material";
import { FormControlWrapper } from "components/Wrappers/FormComponentsWrappers/FormControlWrapper";

export const SingleSelect = ({
  label,
  name,
  handleSelectSingle,
  options,
  selectedOption,
  isDisabled = false,
  isRequired = false,
}) => {
  return (
    <FormControlWrapper fullWidth>
      <Autocomplete
        options={options}
        getOptionLabel={(option) => option.value || option.option}
        value={options.find((opt) => opt.option === selectedOption) || null}
        onChange={(event, newValue) => {
          handleSelectSingle({
            target: {
              name,
              value: newValue ? newValue.option : "",
            },
          });
        }}
        renderInput={(params) => <TextField {...params} label={label} />}
        isOptionEqualToValue={(option, value) => option.option === value.option}
        disabled={isDisabled}
        required={isRequired}
      />
    </FormControlWrapper>
  );
};
